// /* eslint-disable */
// import React from "react";
// import InfoIcon from "../TileComp/InfoIcon";
// import "./DashboardMatrix.css";

// const PercentageIndicator = ({ percentage, activeIndex }) => {
//     return (
//         <div className="indicator-container">
//             <div className="percentage-value">
//                 {percentage !== "0" ? `${percentage}%` : "0%"}
//             </div>

//             <div className="indicator-dots">
//                 {[1, 2, 3].map((idx) => (
//                     <div
//                         key={idx}
//                         className={`dotMatrix ${activeIndex === idx ? `dot-${idx}` : "dot-inactive"}`}
//                     ></div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// const getIndex = (value) => {
//     if (value === "0") {
//         return 3;
//     } else if (value >= 90) {
//         return 1;
//     } else if (value >= 80) {
//         return 2;
//     } else {
//         return 3;
//     }
// };  

// const DashboardMatrix = ({ CRDOData }) => {
//     return (
//         <div className="crdo-card">
//             <div className="dashboard-grid">
//                 <div></div>
//                 <div className="header-box">MIRA Creation</div>
//                 <div className="header-box">GRN Creation</div>

//                 <div className="row-label-new">Timeliness</div>
//                 <div className="value-box">
//                     <PercentageIndicator
//                         percentage={CRDOData["MIRA"]?.[0]?.[0] ?? "0"}
//                         activeIndex={getIndex(CRDOData["MIRA"]?.[0]?.[0] ?? "0")}
//                     />
//                 </div>
//                 <div className="value-box">
//                     <PercentageIndicator
//                         percentage={CRDOData["GRN"]?.[0]?.[0] ?? "0"}
//                         activeIndex={getIndex(CRDOData["GRN"]?.[0]?.[0] ?? "0")}
//                     />
//                 </div>

//                 <div className="row-label-new">Accuracy</div>
//                 <div className="value-box">
//                     <PercentageIndicator
//                         percentage={CRDOData["MIRA"]?.[0]?.[1] ?? "0"}
//                         activeIndex={getIndex(CRDOData["MIRA"]?.[0]?.[1] ?? "0")}
//                     />
//                 </div>
//                 <div className="value-box">
//                     <PercentageIndicator
//                         percentage={CRDOData["GRN"]?.[0]?.[1] ?? "0"}
//                         activeIndex={getIndex(CRDOData["GRN"]?.[0]?.[1] ?? "0")}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DashboardMatrix;


/* eslint-disable */
import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

import "./DashboardMatrix.css";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutGauge = ({ value }) => {
  const numericValue = Number(value) || 0;

  const data = {
    datasets: [
      {
        data: [numericValue, 100 - numericValue],
        backgroundColor: [
          numericValue >= 90
            ? "#28a745"
            : numericValue >= 80
            ? "#ffc107"
            : "#dc3545",
          "#e9ecef"
        ],
        borderWidth: 0
      }
    ]
  };

  const options = {
    cutout: "70%",
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false }
    }
  };

  return (
    <div className="gauge-wrapper">
      <Doughnut data={data} options={options} />
      <div className="gauge-center-text">{numericValue}%</div>
    </div>
  );
};

const DashboardMatrix = ({ CRDOData }) => {
  return (
    <div className="crdo-card">
      <div className="dashboard-grid">
        <div></div>
        <div className="header-box">MIRA Creation</div>
        <div className="header-box">GRN Creation</div>

        <div className="row-label-new">Timeliness</div>
        <div className="value-box">
          <DonutGauge value={CRDOData["MIRA"]?.[0]?.[0] ?? 0} />
        </div>
        <div className="value-box">
          <DonutGauge value={CRDOData["GRN"]?.[0]?.[0] ?? 0} />
        </div>

        <div className="row-label-new">Accuracy</div>
        <div className="value-box">
          <DonutGauge value={CRDOData["MIRA"]?.[0]?.[1] ?? 0} />
        </div>
        <div className="value-box">
          <DonutGauge value={CRDOData["GRN"]?.[0]?.[1] ?? 0} />
        </div>
      </div>
    </div>
  );
};

export default DashboardMatrix;